import { Outlet } from "react-router-dom"

export default function MainPageUser() {

    return(
        <Outlet />
    )
}